import TestSetup from './TestSetup';

export default TestSetup;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/WellData/TestSetup/index.tsx